import React from 'react'
import Section from "../../landingPage/Section"
import CTACard from '../../../components/landingPage/Cards/CardContent&Button'

function CTASection() {
  return (
    <div className="flex md:flex-row justify-around flex-col items-center lg:justify-center lg:gap-40 mb-32 " id="CTA">
        <CTACard title="The XiViX Academy" button="FIND OUT MORE" onClick={()=>{alert('Find out more')}}>
          Our Knowledge Portal frequently conducts training, workshops & webinars to help professionals grow together.
        </CTACard>
        <CTACard title="XiViX Newsletter" button="SUBSCRIBE TO OUR NEWSLETTER" onClick={()=>{alert('SUBSCRIBE')}}>
          Our Periodic newsletter discusses new research and innovation in dentistry. Sounds interesting?
        </CTACard>
    </div>
  )
}

export default CTASection
